var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('login-card',{attrs:{"disable-logout":!_vm.hasAuthUser},on:{"cancel":_vm.redirect,"success":_vm.redirect}}),_c('about-line',{staticClass:"py-2"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }